import axios from "axios";

const clientHttp = axios.create({
    baseURL: 'http://apicrm.techvision.dev/'
})


export default clientHttp;